import {ChangeDetectionStrategy, Component} from '@angular/core';
import {firstValueFrom, Observable, Subject} from 'rxjs';
import {AuthManager, ProfileResponse} from 'shared';
import {map} from 'rxjs/operators';
import { AuthScopes } from 'shared/auth-scopes';
import {ReviewsComponent} from "../store/reviews/reviews.component";
import {ZonedTimeOptions} from "../../shared/zoned-time.component";
import {BreakpointObserver} from '@angular/cdk/layout';

const navigation = [
  {
    title: 'Back office',
    children: [
      {
        title: 'Dashboard',
        url: '/',
        icon: 'dashboard'
      },
      {
        title: 'Customers',
        url: '/customers',
        svgIcon: 'user-black'
      },
      {
        title: 'Devices',
        url: '/devices',
        svgIcon: 'firmwares-black'
      },
      {
        title: 'Walks',
        url: '/walks',
        svgIcon: 'walks-black'
      },
      {
        title: 'Breeds',
        url: '/breeds',
        svgIcon: 'sound_detection_dog_barking'
      }
      // {
      //   title: 'Firmwares',
      //   svgIcon: 'firmwares-black',
      //   children: [
      //     {
      //       title: 'List',
      //       url: '/firmwares'
      //     },
      //     // {
      //     //   title: 'Statuses on devices',
      //     //   url: '/device-firmwares'
      //     // }
      //   ]
      // },
      // {
      //   title: 'Requests',
      //   url: '/requests',
      //   svgIcon: 'requests-black'
      // },
      // {
      //   title: 'Tracks',
      //   url: '/tracks',
      //   svgIcon: 'walks-black'
      // },

    ]
  },
  {
    title: 'Administration panel',
    children: [
      {
        title: 'Support',
        url: '/support',
        icon: 'support_agent',
        scopes: [AuthScopes.UsersManage]
      },
      {
        title: 'Orders',
        url: '/store/orders',
        icon: 'local_atm',
        scopes: [AuthScopes.OrdersManage, AuthScopes.OrdersRead]
      },
      {
        title: 'Resources',
        url: '/resources',
        svgIcon: 'photo-library-outline'
      },
      {
        title: 'Reviews',
        url: '/store/reviews',
        icon: 'star_half',
        scopes: [AuthScopes.ReviewsManage, AuthScopes.ReviewsRead]
      }
    ]
  }
];

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NavBarComponent {
  profile$: Observable<ProfileResponse>;
  navigation$: Observable<any[]>;
  isMobile$: Observable<boolean>;
  zonedTimeView$: Subject<'local' | 'utc'>;

  constructor(private authManager: AuthManager,
              zonedTimeOptions: ZonedTimeOptions,
              breakpointObserver: BreakpointObserver) {
    this.isMobile$ = breakpointObserver.observe('(max-width: 980px)').pipe(map(result => result.matches));
    this.zonedTimeView$ = zonedTimeOptions.defaultView;
    let zonedDefaultView = localStorage.getItem('zoned-time-default-view');
    if (zonedDefaultView == 'local') this.zonedTimeView$.next('local');
    if (zonedDefaultView == 'utc') this.zonedTimeView$.next('utc');

    const filterNavigations = (navigations: any[], scopes: string[]): any[] => {
      if (!scopes) { return navigations; }

      return navigations
        .map(item => ({...item}))
        .map(item => {
          if (item.children && item.children.length) {
            item.children = filterNavigations(item.children, scopes);
            if (!item.children.length) { return null; }
          }
          return item;
        })
        .filter(item => !!item)
        .filter(item => !item.scopes || item.scopes.some(r => scopes.indexOf(r) >= 0));
    };

    this.profile$ = authManager.profile$;
    this.navigation$ = authManager
      .profile$
      .pipe(map(
        profile => profile.roles && profile.roles.includes('Admin')
          ? navigation
          : filterNavigations(navigation, profile.scopes || [])
      ));
  }

  async switchZonedTime(): Promise<void> {
    let current = await firstValueFrom(this.zonedTimeView$);
    let newValue: 'utc' | 'local' = current == 'local' ? 'utc' : 'local';
    this.zonedTimeView$.next(newValue);
    localStorage.setItem('zoned-time-default-view', newValue);
  }

  async signOut(): Promise<void> {
    await this.authManager.signOut();
  }
}
